import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToHour'
})
export class NumberToHourPipe implements PipeTransform {

  transform(value: number): string {

    //Para hora subida...
    if (value.toString().length == 1) {
      return `00:00:${value.toString().padStart(2, "0")}`;
    }
    if (value.toString().length == 2) {
      return `00:00:${value.toString().substring(0, 1).padStart(2, "0")}`;
    }
    if (value.toString().length == 3) {
      return `00:${value.toString().substring(0, 1).padStart(2, "0")}:${value.toString().substring(1, 3).padStart(2, "0")}`;
    }
    if (value.toString().length == 4) {
      return `00:${value.toString().substring(0, 2).padStart(2, "0")}:${value.toString().substring(2, 4).padStart(2, "0")}`;
    }
    if (value.toString().length == 5) {
      return `${value.toString().substring(0, 1).padStart(2, "0")}:${value.toString().substring(1, 3).padStart(2, "0")}:${value.toString().substring(3, 5).padStart(2, "0")}`;
    }
    if (value.toString().length == 6) {
      return `${value.toString().substring(0, 2).padStart(2, "0")}:${value.toString().substring(2, 4).padStart(2, "0")}:${value.toString().substring(4, 6).padStart(2, "0")}`;
    }

    // if (value.toString().length == 5) {
    //   return `${value.toString().substring(0,1).padStart(2,"0")}:${value.toString().substring(1,3).padStart(2,"0")}:${value.toString().substring(3,5).padStart(2,"0")}`;
    // }

    // if (value.toString().length == 6) {
    //   return `${value.toString().substring(0,2).padStart(2,"0")}:${value.toString().substring(2,4).padStart(2,"0")}:${value.toString().substring(4,6).padStart(2,"0")}`;
    // }

    return ``;
  }

}
